import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=bf310dc8&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/wallet/_global.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/layout.scss?vue&type=style&index=1&id=bf310dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf310dc8",
  null
  
)

export default component.exports